import {Suspense, useEffect, useState} from "react";
import {MapContainer, Marker, Popup, TileLayer, useMap} from "react-leaflet";

function MapController({lat, lng}){
    const map = useMap();

    useEffect(() => {
        if (map) { // check if map is defined.
            map.setView([lat, lng]);
        }
    }, [map, lat, lng]); //depend on map, lat and lng

    return null; // This component doesn't render anything
}

export default MapController;